import React from 'react';
import { Exception } from 'api/candidates/types/Report';
import classify from '../../../../lib/classify';
import Notification from './Notification';

const getNewVerificationName = (object: string, exceptionType: string) => {
  if (
    object === 'matrix_verification' &&
    MatrixExceptionInfoMap[exceptionType]
  ) {
    return MatrixExceptionInfoMap[exceptionType];
  }

  return classify(object);
};

const MatrixExceptionInfoMap: Record<string, string> = {
  id_documentation_requested: 'IdVerification',
  ssn_confirmation_requested: 'SsnCheck',
  ssn_documentation_requested: 'SsnVerification',
};

const VerificationNotification: React.FC<{
  verification: Record<string, any>;
}> = ({ verification }) => {
  const { object, exceptionType } = verification;

  const verificationName = getNewVerificationName(object, exceptionType);

  return (
    <Notification
      verificationName={verificationName}
      verification={verification}
    />
  );
};

const Verifications: React.FC<{
  verifications: Exception[];
  candidate?: any;
}> = ({ verifications, candidate }) => {
  if (!verifications || verifications.length === 0) return null;

  return (
    <div className='report__verifications'>
      {verifications.map((verification, i) => {
        return (
          <VerificationNotification
            key={`div-${i + 1}`}
            verification={verification}
          />
        );
      })}
    </div>
  );
};

export default Verifications;
